import { styles, mobileStyles } from "./Style";
import { useIsMobile } from "./useIsMobile.js";
import { ToptalBadge } from "./ToptalBadge.js";
import { useState } from "react";

function ProfileLink(props) {
    const [hover, setHover] = useState(false);
    return (
        <a
            href={props.href}
            target="_blank"
            rel="noopener noreferrer"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            style={{
                ...styles.profileLink,
                backgroundColor: hover ? "#00ccff" : "#fff",
                color: hover ? "#08323d" : "#0a7c9c",
            }}
        >
            {props.children}
        </a>
    );
}

export function AboutMe(props) {
    const isMobile = useIsMobile();
    return <div style={isMobile ? {...styles.AboutMe, ...mobileStyles.AboutMe} : styles.AboutMe}>
        <img style={{borderRadius: "50%", maxWidth: "100%"}} src={process.env.PUBLIC_URL + "mypic.jpg"} alt="Image of my big fat face" />
        <h2>ABOUT ME</h2>
        <div style={styles.aboutColumns}>
            <div style={styles.aboutColumn}>
                <p>Howdy, I'm John. Thanks for visiting my website!</p>
                <p>I'm 21 years old. I've been programming since age 8, and I'm committed to using my skills to make the world a better place.</p>
                <p>I don't complain. I am alive. In the 21st century. In the USA. I have won the greatest lottery of all time.</p>
                <p>I enjoy putting myself in awkward situations to become a better person.</p>
            </div>
            <div style={styles.aboutColumn}>
                <p>My hobbies include programming, playing sports, dancing, enjoying math, studying science, analyzing music, casual chess, memorizing jokes and riddles, studying social dynamics, understanding people, and language theory.</p>
                <p>Some of my favorite books of all time are Endurance: Shackleton's Incredible Voyage, The Greatest Estate Developer, Jane Eyre, and Fullmetal Alchemist.</p>
            </div>
        </div>
        <p>Reach out to me: <a href="mailto:harry@harrybaldwig.com">harry@harrybaldwig.com</a></p>
        <div style={styles.profileLinks}>
            <ProfileLink href="https://github.com/DabaMcD">Github</ProfileLink>
            <ProfileLink href="https://www.linkedin.com/in/john-harrison-4190a8256/">LinkedIn</ProfileLink>
            <ProfileLink href="https://www.upwork.com/freelancers/~01a9cd8f9f0db8cf77">UpWork</ProfileLink>
            <ProfileLink href="https://www.khanacademy.org/profile/dabamcd/projects">Khan Academy</ProfileLink>
        </div>
        <div style={{display: "flex", justifyContent: "center", marginTop: 28}}>
            <ToptalBadge />
        </div>
    </div>
}
